import React from 'react';
import { SectionUIProps, TeamCompositionPayload } from '~/common/types/types';
import { SectionLayout, TeamCompositionList } from '~/components/common/common';
import * as styles from './team-composition.module.scss';

type Props = SectionUIProps & {
  payload: TeamCompositionPayload;
};

const TEAM_COMPOSITION_CLASSES = {
  title: styles.title,
  wrapper: styles.wrapper,
};

const TeamComposition: React.FC<Props> = ({ payload, sectionHighlight }) => {
  const { title, items } = payload;

  return (
    <SectionLayout
      classes={TEAM_COMPOSITION_CLASSES}
      sectionHighlight={sectionHighlight}
      headingMessage={title}
    >
      <TeamCompositionList items={items} />
    </SectionLayout>
  );
};

export { TeamComposition };
